// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__327Em","item":"Nav_item__3wneH","activeNavLink":"Nav_activeNavLink__1chYR"};